module.exports = "/static-assets/_next/static/images/island-thumb-9ab6a5ad771b680b0e9748185a016658.jpg";